import * as React from 'react'
import { attachGDPREvent } from 'lib/CookieGDPR/attachGDPREvent'

attachGDPREvent()
